import {CvsUtils} from '../cvs/cvs.utils';
import {saveAs} from 'file-saver/FileSaver';
import {Injectable} from '@angular/core';
import {UserService} from '../core/ecv-http-services/services/user.service';


@Injectable()
export class FileSaverService {

  private static MAX_STORAGE_SIZE = 10;
  originalFilesStore = new Map();

  constructor(private userService: UserService){
  }

  saveCvFile(cvId) {
    const originalFile = this.originalFilesStore.get(cvId);
    if (originalFile !== undefined) {
      saveAs(originalFile.blob, originalFile.name);
    } else {
      if (this.originalFilesStore.size > FileSaverService.MAX_STORAGE_SIZE) {
        this.originalFilesStore.clear();
      }
      this.userService.getCvOriginalFile(cvId).subscribe(response => {
        const blob = CvsUtils.getBlobFromCV(response.content);
        const name = response.filename ? response.filename : Date.now();
        this.originalFilesStore.set(cvId, {blob: blob, name: name});
        saveAs(blob, name);
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/shared/file-saver-service.ts